import ChevronDownLine from "./ChevronDownLine";
import ChevronUpLine from "./ChevronUpLine";
import MoneyStack from "./MoneyStack";
import EthTokenIcon from "./EthTokenIcon";
import Bank from "./Bank";
import RedThermometer from "./RedThermometer";
import YellowThermometer from "./YellowThermometer";
import GreenThermometer from "./GreenThermometer";
import AddIcon from "./AddIcon";
import FilledAddIcon from "./FilledAddIcon";
import MinusIcon from "./MinusIcon";
import FilledMinusIcon from "./FilledMinusIcon";
import TooltipPrompt from "./TooltipPrompt";
import Expand from "./Expand";
import Success from "./Success";
import Failure from "./Failure";
import MetaMaskIcon from "./MetaMaskIcon";
import BlueAddIcon from "./BlueAddIcon";
import AVAX from "./AVAX";
import sJOE from "./sJOE";
import USDC from "./USDC";
import WAVAX from "./WAVAX";
import WETH from "./WETH";
import DANGER from "./DANGER";
import BC from "./BC";
import qiUSDC from "./qiUSDC";
import PREON from "./InvertedPreon";
import LUSD from "./LUSD";
import JLP from "./JLP";
import CLP from "./CurveLP";
import WalletConnect from "./WalletConnect";
import WBTC from "./WBTC";
import vePREON from "./vePREON";
import av3CRV from "./av3CRV";
import WETHAVAX from "./WETHAVAX";
import WAVAXUSDC from "./WAVAXUSDC";
import qiETH from "./qiETH";
import qiAVAX from "./qiAVAX";
import qiBTC from "./qiBTC";
import qiUSDCn from "./qiUSDCn";
import sAVAX from "./sAVAX";
import aUSDT from "./aUSDT";
import aUSDC from "./aUSDC";
import aDAI from "./aDAI";
import aWETH from "./aWETH";
import aWAVAX from "./aWAVAX";
import qiDAI from "./qiDAI";
import qiUSDTn from "./qiUSDTn";
import PTP from "./PTP";
import calculator from "./calculator";
import USDPlus from "./USDPlus";
import stMATIC from "./stMATIC";
import WMATIC from "./WMATIC";
import Balancer from "./Balancer";

import CollapseIcon from "./CollapseIcon";
const library = {
  MoneyStack,
  ChevronDownLine,
  ChevronUpLine,
  EthTokenIcon,
  RedThermometer,
  YellowThermometer,
  GreenThermometer,
  Bank,
  AddIcon,
  FilledAddIcon,
  MinusIcon,
  FilledMinusIcon,
  BlueAddIcon,
  TooltipPrompt,
  Expand,
  Success,
  Failure,
  MetaMaskIcon,
  AVAX,
  sJOE,
  USDC,
  WAVAX,
  WETH,
  DANGER,
  BC,
  qiUSDC,
  PREON,
  LUSD,
  JLP,
  CLP,
  WalletConnect,
  WBTC,
  vePREON,
  av3CRV,
  "WETH-WAVAX JLP": WETHAVAX,
  "AVAX-USDC JLP": WAVAXUSDC,
  qiETH,
  qiBTC,
  qiUSDCn,
  qiAVAX,
  sAVAX,
  aUSDT,
  aUSDC,
  aDAI,
  aWETH,
  aWAVAX,
  qiDAI,
  qiUSDTn,
  CollapseIcon,
  PTP,
  calculator,
  USDPlus,
  stMATIC,
  WMATIC,
  Balancer
};

export default library;
